import { render, staticRenderFns } from "./SuperLink.vue?vue&type=template&id=4c1904d4"
import script from "./SuperLink.vue?vue&type=script&lang=js"
export * from "./SuperLink.vue?vue&type=script&lang=js"
import style0 from "./SuperLink.vue?vue&type=style&index=0&id=4c1904d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports